/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOAD_MOST_USED = 'MFE/CHECKOUT/LOAD/MOST_USED_PAYMENT_METHODS';
export const IS_USER_SELECTED_PAYMENT_METHOD = 'MFE/CHECKOUT/SET/USER_SELECTED_PAYMENT_METHOD';
export const IS_PERSONLAIZED_PAYMENT_METHOD_SELECTED = 'MFE/CHECKOUT/SET/PERSONLAIZED_PAYMENT_METHOD_SELECTED';

export default { LOAD_MOST_USED, IS_USER_SELECTED_PAYMENT_METHOD, IS_PERSONLAIZED_PAYMENT_METHOD_SELECTED };
